import request from "../utils/request"

export function fetchAdminUserList(params) {
  return request({
    url: "/admin/users",
    method: "get",
    params
  })
}

export function fetchAdminUserPets(userId) {
  return request({
    url: `/admin/users/${userId}/pets`,
    method: "get"
  })
}

export function updateAdminUser(userId, data) {
  return request({
    url: `/admin/users/${userId}`,
    method: "put",
    data
  })
}

export function updateAdminUserStatus(userId, status) {
  return request({
    url: `/admin/users/${userId}/status`,
    method: "put",
    data: { status }
  })
}

export function deleteAdminUser(userId) {
  return request({
    url: `/admin/users/${userId}`,
    method: "delete"
  })
}

export function restoreAdminUser(userId) {
  return request({
    url: `/admin/users/${userId}/restore`,
    method: "post"
  })
}

export function clearAdminUserData(userId) {
  return request({
    url: `/admin/users/${userId}/clear-data`,
    method: "post"
  })
}

export function exportAdminUsers(params) {
  return request({
    url: "/admin/users/export",
    method: "get",
    params,
    responseType: "blob",
    timeout: 60000
  })
}

// 用户「我的」页面预览：复用小程序公开资料接口，只读展示
export function fetchUserPublicProfile(userId) {
  return request({
    url: `/users/${userId}/public-profile`,
    method: "get"
  })
}

export function fetchUserCurrentTheme(openId) {
  return request({
    url: "/app/theme/current",
    method: "get",
    params: { openId }
  })
}

export function fetchPetCareRecords(openId, petId) {
  return request({
    url: "/care-records",
    method: "get",
    params: {
      openId,
      petId,
      todayOnly: false,
      limit: 30
    }
  })
}

export function fetchPetWeightRecords(openId, petId) {
  return request({
    url: "/pet-weight-records",
    method: "get",
    params: {
      openId,
      petId,
      limit: 30
    }
  })
}

export function fetchPetCostRecords(openId, petId) {
  return request({
    url: "/pet-cost-records",
    method: "get",
    params: {
      openId,
      petId,
      limit: 30
    }
  })
}

export function fetchPetCostSummary(openId, petId) {
  return request({
    url: "/pet-cost-records/summary",
    method: "get",
    params: {
      openId,
      petId
    }
  })
}

export function fetchPetFeedingPlan(ownerUserId, petId) {
  return request({
    url: "/pet-feeding-plans/current",
    method: "get",
    params: {
      ownerUserId,
      petId
    }
  })
}
